export default __webpack_public_path__ + "static/production-1-babea71f092c2c682780476d464d12fd.png";